import { env as envConfig } from './env'

// TODO: Improve types to infer return type based on the env name
export const env = <R = string>(name: keyof typeof envConfig, fallback?: R) => {
  return (envConfig[name] ?? fallback) as unknown as R
}

export const VERSION = env('VITE_ENV_VERSION', 'local')

/** Which STAGE we're currently running in */
export const STAGE = env('REACT_APP_STAGE')

/** Whether we're running in a local environment */
export const IS_LOCAL = STAGE === 'local'

/** Whether we're running in a production environment */
export const IS_PRODUCTION = STAGE === 'prod'

/** @deprecated seems not to be used, should be removed if confirmed */
export const RULE_SOURCE_SEPARATOR = '/'

/** When will the desktop stepper switch into mobile one */
export const STEPPER_DESKTOP_LIMIT = 8

/** Datadog id and client token */
export const DATADOG_APPLICATION_ID = 'df1ff5a4-412d-4da3-b4d6-99b2f797fc41'
export const DATADOG_CLIENT_TOKEN = 'pubcbfbb4b2a92ed722ad8c1e40b2880553'

/**
 * Measures the time spent between the initial execution of the App bundle
 * and the first time the Journey App renders a Step content to the end-user.
 *
 * This is meant to track how much time the user is waiting for that.
 */
export const TIME_TO_FIRST_RENDER_METRIC = 'timeToFirstRender'

/**
 * Measures the time spent between the initial execution of the App bundle
 * and the App becoming **ready** to start rendering the Journey, regardless of the time of
 * the actual first render.
 */
export const TIME_TO_READINESS = 'timeToReadiness'

/**
 * Indicates the 360 Portal App URL.
 * Currently used to validate the origin of the events coming from it.
 *
 * TODO: Remove `REACT_APP_JOURNEY_BUILDER_URL` after canary + stable releases
 */
export const PORTAL_APP_URL =
  env('REACT_APP_PORTAL_URL') ?? env('REACT_APP_JOURNEY_BUILDER_URL')

export const JOURNEYS_PRICING_API = env('REACT_APP_JOURNEYS_PRICING_API')
/* @todo There's redundancy between the following two variables, we should keep one only */
export const ADDRESS_SUGGESTIONS_API = env('REACT_APP_ADDRESS_SUGGESTIONS_API')
export const ADDRESS_SUGGESTIONS_API_URL = env(
  'REACT_APP_ADDRESS_SUGGESTIONS_API_URL'
)
export const ANALYTICS_API_BASE_URL = env('REACT_APP_ANALYTICS_API_BASE_URL')
export const JOURNEYS_SUBMISSION_API = env('REACT_APP_JOURNEYS_SUBMISSION_API')
export const JOURNEYS_API_BASE_URL = env('REACT_APP_JOURNEYS_API_BASE_URL')
export const VALIDATION_RULES_API_BASE_URL = env(
  'REACT_APP_VALIDATION_RULES_API_BASE_URL'
)

export const IMAGE_PREVIEW_API_URL = env('REACT_APP_IMAGE_PREVIEW_API_URL')
export const FILE_API_URL = env('REACT_APP_FILE_API_URL')
export const JOURNEY_BUILDER_URL = env('REACT_APP_JOURNEY_BUILDER_URL')
export const APPS_API_URL = env('REACT_APP_APPS_API_URL')

/**
 * Although known as "Google" API, we should call it maps API going forward
 * since it also support other providers like Tetraeder.
 */
export const MAPS_API_BASE_URL = env('REACT_APP_GOOGLE_MAPS_API_URL')

export const DESIGN_BUILDER_API_BASE_URL = env(
  'REACT_APP_DESIGN_BUILDER_API_URL'
)

/**
 * Google Maps API Key.
 * Used throught `@googlemaps/js-api-loader` to embed Google Maps.
 */
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDCbX7jMWETrRawPfO_BpDV_owCv7V2LgM'

export const rendererConfig = {
  STAGE,
  GOOGLE_MAPS_API_URL: MAPS_API_BASE_URL,
  PRICING_API_URL: env('REACT_APP_PRICING_API_URL'),
  FILE_API_URL,
  IMAGE_PREVIEW_API_URL,
  ADDRESS_API_URL: env('REACT_APP_ADDRESS_API_URL'),
  ADDRESS_SUGGESTIONS_API_URL,
  PREVIOUS_PROVIDER_URL: env('REACT_APP_PREVIOUS_PROVIDER_URL'),
  ENTITY_API_URL: env('REACT_APP_ENTITY_API_URL'),
  CUSTOMER_PORTAL_API_URL: env('REACT_APP_CUSTOMER_PORTAL_API_URL'),
  METERING_API_URL: env('REACT_APP_METERING_API_URL'),
  JOURNEYS_API_BASE_URL: `${JOURNEYS_API_BASE_URL}/v1/journey`,
  JOURNEYS_API_URL: env('REACT_APP_JOURNEYS_API_URL'),
  VALIDATION_RULES_API_BASE_URLL: VALIDATION_RULES_API_BASE_URL
}
